module.exports = __webpack_public_path__ + "static/hayesandjarvis-31cb2e89ec18cfeaacdec047ef543fb1.jpg";